type FormStateType = 'builder' | 'renderer' | 'share' | 'results' | 'settings' | null;

export const FORM_TYPE = {
  REGISTRATION: 'REGISTRATION',
  EVALUATION: 'EVALUATION',
};

export const DEVICE_TYPE = {
  DESKTOP: 'Desktop',
  MOBILE: 'Mobile',
};

export const ROUTE_TYPE: Record<string, FormStateType> = {
  BUILDER: 'builder',
  RENDERER: 'renderer',
};

export const UPLOAD_STATUS = {
  UPLOADING: 'UPLOADING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export const API_STATUS = {
  SUCCESS: 'fulfilled',
  LOADING: 'pending',
};

/** Rows fetched per select-field-data request. Search narrows within this window. */
export const SELECT_FIELD_DATA_LIMIT = 20;

/** Idle time before a typed search term triggers a request. */
export const SELECT_SEARCH_DEBOUNCE_MS = 300;

export const FORM_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
};

export const ERROR_MESSAGES = {
  UNKNOWN: 'Something went wrong. Please try again.',
  FACE_AUTH: 'File Processing failed. Please try again.',
};

export const FACE_DETECTION_MESSAGES = {
  NO_FACE: 'No face detected. Please ensure your face is clearly visible and try again.',
  MULTIPLE_FACES: 'Multiple faces detected. Please capture a photo with only your face.',
  FACE_DETECTED: 'Face detected.',
  FACE_NOT_CLEAR: 'Face not clear. Please try again.',
};

export const VALIDATION_ERROR_MESSAGES = {
  REQUIRED: 'This is a required field',
};

export const PHONE_NUMBER_ERROR_MESSAGES = {
  INVALID: 'Invalid phone number. Please try again.',
};

export const DEFAULT_SENTRY_NETWORK_URLS = [
  'https://supergraph.talview.com/v1/graphql',
  'https://top-api.talview.org/v1/graphql',
];

export const URL_MAX_LENGTH = 2000;

export const HTTP_PROTOCOL_REGEX = /^https?:\/\//i;

export const URL_VALIDATION_ERROR = {
  INVALID_URL: 'invalidUrl',
  MAX_LENGTH: 'maxLength',
} as const;
